import React from 'react';
import { css } from 'styled-components/macro';
import { ResponsiveLine, LineSvgProps } from '@nivo/line';
import { LineItem } from 'app/components/Charts/line/data';
import { NoDataReportedMessage } from 'app/components/Charts/common/NoDataReportedMessage';

const containercss = css`
  width: 100%;
  height: 400px;
  position: relative;

  ::after {
    content: 'Not available';
    display: block;
    width: 100%;
    text-align: center;
    position: absolute;
    top: calc(50% - 11px);
    font-weight: bold;
    font-size: 16.015px;
    color: rgba(61, 61, 61, 0.6);
  }
`;

export function DatalessLinechart() {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const props: LineSvgProps = {
    data: DatalessMock,
    margin: { top: 20, right: 15, bottom: 50, left: 80 },
    axisBottom: {
      orient: 'bottom',
      tickSize: 0,
      tickPadding: 15,
      legend: '',
    },
    axisLeft: {
      orient: 'left',
      tickSize: 0,
      tickValues: 8,
      tickPadding: 25,
      format: (v: any) => currencyFormatter.format(v),
    },
    colors: (n: { color: string }) => 'rgba(0,0,0,0.0)',
    gridYValues: 6,
    enableGridX: false,
    isInteractive: false,
    theme: {
      axis: {
        ticks: {
          text: {
            fontSize: 12,
            fill: 'rgba(61, 61, 61, 0.6)',
            fontWeight: 'bold',
          },
        },
      },
      grid: {
        line: { stroke: '#F7F7F7' },
      },
      crosshair: {
        line: {
          stroke: 'rgba(61, 61, 61, 0.6)',
        },
      },
      tooltip: {
        container: {
          borderRadius: 20,
        },
      },
    },
  };

  return (
    <>
      <div css={containercss}>
        <ResponsiveLine {...props} />
      </div>
      <NoDataReportedMessage />
    </>
  );
}

const DatalessMock: LineItem[] = [
  {
    id: 'empty',
    color: '#E5E5E5',
    data: [
      {
        x: 2005,
        y: 0,
      },
      {
        x: 2006,
        y: 20000,
      },
      {
        x: 2007,
        y: 40000,
      },
      {
        x: 2008,
        y: 60000,
      },
      {
        x: 2009,
        y: 80000,
      },
      {
        x: 2010,
        y: 100000,
      },
      {
        x: 2011,
        y: 120000,
      },
      {
        x: 2012,
        y: 140000,
      },
      {
        x: 2013,
        y: 120000,
      },
    ],
  },
];
